import type {FulfillmentStatus} from '../jobs/assignment-grouping-utils'
import {formatJobDate, formatJobTime} from '../jobs/job-schedule-format'

export function formatJobWindow(startTime: string | null, endTime: string | null): string {
    if (!startTime) {
        return '—'
    }
    if (!endTime) {
        return formatJobTime(startTime)
    }
    return `${formatJobTime(startTime)} – ${formatJobTime(endTime)}`
}

export type JobDateLines = {
    primary: string
    secondary: string | null
}

export function formatJobDateLines(startDate: string, endDate: string | null): JobDateLines {
    const primary = formatJobDate(startDate)
    if (!endDate || endDate === startDate) {
        return {primary, secondary: null}
    }
    return {primary, secondary: formatJobDate(endDate)}
}

export type RequirementFulfillmentCounts = {
    workersRequired: number
    workersAssigned: number
    equipmentRequired: number
    equipmentAssigned: number
}

export type FulfillmentLine = {
    kind: 'workers' | 'equipment'
    label: string
    status: FulfillmentStatus
}

function lineFulfillmentStatus(assigned: number, required: number): FulfillmentStatus {
    if (assigned < required) {
        return 'under'
    }
    if (assigned > required) {
        return 'over'
    }
    return 'met'
}

/** Requirements column lines — empty when the job has no worker or asset requirements. */
export function formatFulfillmentLines(
    fulfillment: RequirementFulfillmentCounts,
): FulfillmentLine[] {
    const lines: FulfillmentLine[] = []

    if (fulfillment.workersRequired > 0) {
        lines.push({
            kind: 'workers',
            label: `${fulfillment.workersAssigned}/${fulfillment.workersRequired} workers`,
            status: lineFulfillmentStatus(fulfillment.workersAssigned, fulfillment.workersRequired),
        })
    }

    if (fulfillment.equipmentRequired > 0) {
        lines.push({
            kind: 'equipment',
            label: `${fulfillment.equipmentAssigned}/${fulfillment.equipmentRequired} equipment`,
            status: lineFulfillmentStatus(
                fulfillment.equipmentAssigned,
                fulfillment.equipmentRequired,
            ),
        })
    }

    return lines
}
